import { checkEmail } from "../helpers/check-email"
import { checkPhone } from "../helpers/check-phone"
import { checkSMS } from "../helpers/check-sms"
import { checkText } from "../helpers/check-text"

const inputsRequired = document.querySelectorAll(".input-container[data-required]")
const inputsSMS = document.querySelectorAll(".input-container__input[name='sms']")

inputsSMS.forEach(elem => {
    const {acceptSMS} = checkSMS(elem)
    elem.addEventListener("blur", () => {
        acceptSMS()
    })
})

inputsRequired.forEach(elem => {
    const input = elem.querySelector(".input-container__input[data-validate]")
    switch(input.getAttribute('data-validate')){
        case 'email':
            const {acceptEmail} = checkEmail(elem)
            input.addEventListener("blur", () => {
                acceptEmail()
            })
            break;
        case 'tel':
            const {acceptPhone} = checkPhone(elem)
            input.addEventListener("blur", () => {
                acceptPhone()
            })
            break
        default: 
            const {acceptText} = checkText(elem)
            input.addEventListener("blur", () => {
                acceptText()
            })
            break
    }
})


